/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FoodSourceDropdown } from '../../models/food-source-dropdown';

export interface ApiFoodsourceDropDownGet$Params {
  'api-version'?: string;
}

export function apiFoodsourceDropDownGet(http: HttpClient, rootUrl: string, params?: ApiFoodsourceDropDownGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FoodSourceDropdown>>> {
  const rb = new RequestBuilder(rootUrl, apiFoodsourceDropDownGet.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FoodSourceDropdown>>;
    })
  );
}

apiFoodsourceDropDownGet.PATH = '/api/foodsource/drop-down';
